import script from "./LiveChatLauncher.vue?vue&type=script&lang=ts&setup=true"
export * from "./LiveChatLauncher.vue?vue&type=script&lang=ts&setup=true"

import "./LiveChatLauncher.vue?vue&type=style&index=0&id=af5f66de&lang=scss"

const __exports__ = script;

export default __exports__